/** Same date handling as Overview `convertToDate` / `normalizeOverviewAppointment`. */

export const convertToDate = (dateValue) => {
  if (!dateValue) return null;

  try {
    if (dateValue instanceof Date) {
      return dateValue;
    }
    if (dateValue?.toDate && typeof dateValue.toDate === 'function') {
      return dateValue.toDate();
    }
    if (dateValue?.seconds) {
      return new Date(dateValue.seconds * 1000);
    }
    const date = new Date(dateValue);
    return isNaN(date.getTime()) ? null : date;
  } catch {
    return null;
  }
};

export const normalizeCompanyAppointmentDoc = (id, data) => {
  const dateTime = convertToDate(data.dateTime);
  let endTime = convertToDate(data.endTime);
  if (dateTime && !endTime && typeof data.duration === 'number') {
    const ms = data.duration * 60 * 1000;
    endTime = new Date(dateTime.getTime() + ms);
  }

  return {
    id,
    ...data,
    dateTime,
    endTime,
    updatedAt: convertToDate(data.updatedAt),
    createdAt: convertToDate(data.createdAt),
  };
};

export const resolveAppointmentEmployeeId = (appointment) =>
  appointment?.employeeId ||
  appointment?.staffId ||
  appointment?.employee?.assignedStaffId ||
  appointment?.employee?.id ||
  null;

/** `companies/{companyId}/meetings` documents — same date fields as appointments. */
export function normalizeMeetingDoc(id, data) {
  const dateTime = convertToDate(data.dateTime);
  let endTime = convertToDate(data.endTime);
  if (dateTime && !endTime && typeof data.duration === 'number') {
    endTime = new Date(dateTime.getTime() + data.duration * 60 * 1000);
  }

  return {
    id,
    ...data,
    type: 'meeting',
    dateTime,
    endTime,
    updatedAt: convertToDate(data.updatedAt),
    createdAt: convertToDate(data.createdAt),
  };
}
